<template>
  <div>
    <div class="col-md-3 col-sm-6 col-xs-12">
        <div class="info-box">
        <span class="info-box-icon box-green"><i class="ion ion-cash"></i></span>

        <div class="info-box-content">
            <span class="info-box-text">Total Balance</span>
            <span class="info-box-number">{{totalBalAmt}}</span>
        </div>
        <!-- /.info-box-content -->
        </div>
        <!-- /.info-box -->
    </div>
    <!-- fix for small devices only -->
    <div class="clearfix visible-sm-block"></div>

    <div class="col-md-3 col-sm-6 col-xs-12">
        <div class="info-box">
        <span class="info-box-icon box-red"><i class="fa fa-university"></i></span>

        <div class="info-box-content">
            <span class="info-box-text">Bank Balance</span>
            <span class="info-box-number">{{bankBalanceAmt}}</span>
        </div>
        <!-- /.info-box-content -->
        </div>
        <!-- /.info-box -->
    </div>
    <!-- /.col -->
    <div class="col-md-3 col-sm-6 col-xs-12">
        <div class="info-box">
        <span class="info-box-icon box-blue"><i class="fa fa-inr"></i></span>

        <div class="info-box-content">
            <span class="info-box-text">Cash Balance</span>
            <span class="info-box-number">{{cashBalanceAmt}}</span>
        </div>
        <!-- /.info-box-content -->
        </div>
        <!-- /.info-box -->
    </div>
    <!-- /.col -->
    
    
    <div class="col-md-3 col-sm-6 col-xs-12">
      <div class="info-box">
        <span class="info-box-icon box-yellow"><i class="fa fa-shopping-bag"></i></span>

        <div class="info-box-content">
            <span class="info-box-text">SMS Balance</span>
            <span class="info-box-number">{{smsbal}}</span>
        </div>
      </div>
        <!-- /.info-box -->
    </div>
  </div>
</template>
<script>
export default {
  name: 'my-component',
  props: ['message'],
  data () {
    return {
      bankBalance: 0,
      cashBalance: 0,
      fyopeningbalance: {},
      settingFyRecord: '',
      smsbal: 0
    }
  },
  computed: {
    bankBalanceAmt () {
      if (this.message[4]) {
        this.bankBalance = ((this.message[4].bank[0][0].totalBankDr + parseFloat(this.message[4].bank[2][0].totalBankOpeningBalance)) - this.message[4].bank[1][0].totalBankCr).toFixed(2)
      }
      return this.bankBalance
    },
    cashBalanceAmt () {
      if (this.message[3]) {
        this.cashBalance = ((this.message[3].cash[0][0].totalCashDr + parseFloat(this.message[3].cash[2][0].totalCashOpeningBalance)) - this.message[3].cash[1][0].totalCashCr).toFixed(2)
      }
      return this.cashBalance
    },
    totalBalAmt () {
      var bankBalance = 0
      var cashBalance = 0
      var totalAmount = 0
      if (this.message[4]) {
        bankBalance = ((this.message[4].bank[0][0].totalBankDr + parseFloat(this.message[4].bank[2][0].totalBankOpeningBalance)) - this.message[4].bank[1][0].totalBankCr).toFixed(2)
      }
      if (this.message[3]) {
        cashBalance = ((this.message[3].cash[0][0].totalCashDr + parseFloat(this.message[3].cash[2][0].totalCashOpeningBalance)) - this.message[3].cash[1][0].totalCashCr).toFixed(2)
      }
      totalAmount = parseFloat(bankBalance) + parseFloat(cashBalance)
      return parseFloat(totalAmount + 0).toFixed(2)
    }
  },
  methods: {
    loadData () {
      this.$axios.get('user/smsbalance', {headers: { Authorization: 'Bearer ' + localStorage.token }})
      .then((response) => response.data)
      .then((data) => {
        if (data.Balance === '0') {
          this.smsbal = 0
        } else {
          this.smsbal = data.Balance.substring(8)
        }
      })
      .catch(function (error) {
        console.log(error.message)
      })
    },
    canAccess (perm) {
      return this.$store.state.permissions.includes(perm)
    }
  },
  created () {
    this.loadData()
  }
}
</script>
<style scoped>
  .info-box {
    border-radius:10px;
    box-shadow: 0px 0px 4px gray;
  }
  .box-red {
    background-color:#ec1c22;
    color: #fff;
  }
  .box-green {
    background-color: #0e8c0e;
    color: #fff;
  }
  .box-blue {
    background-color: #003c60;
    color: #fff;
  }
  .box-yellow {
    background-color: #a300ff;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// balancerecord.vue?58bb2f98